<template>
  <CommonLicenseComponentsWrapper
    :component="component"
    licenseName="intro"
  />
</template>

<script>
import AgreementIntroPage from './AgreementIntroPage';
import CommonLicenseComponentsWrapper from '../CommonLicenseComponents/Wrapper';

export default {
  components: {
    CommonLicenseComponentsWrapper,
  },
  data() {
    return {
      component: AgreementIntroPage,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/FilmLicenseAgreementIntro/index.vue